var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_2260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88393 8.00002L15.8169 1.06697C16.061 0.822881 16.061 0.427132 15.8169 0.18307C15.5729 -0.0609921 15.1771 -0.0610233 14.933 0.18307L7.99999 7.11612L1.06697 0.18307C0.822881 -0.0610233 0.427132 -0.0610233 0.18307 0.18307C-0.0609921 0.427163 -0.0610233 0.822912 0.18307 1.06697L7.11609 7.99999L0.18307 14.933C-0.0610233 15.1771 -0.0610233 15.5729 0.18307 15.8169C0.305101 15.939 0.465069 16 0.625038 16C0.785006 16 0.944944 15.939 1.06701 15.8169L7.99999 8.88393L14.933 15.8169C15.055 15.939 15.215 16 15.375 16C15.5349 16 15.6949 15.939 15.8169 15.8169C16.061 15.5729 16.061 15.1771 15.8169 14.933L8.88393 8.00002Z",
    fill: "#777E8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_2260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.97af854f20b69b888baf9e77dbd87a61.svg";
export { ForwardRef as ReactComponent };